module.exports = __webpack_public_path__ + "img/top.ce8bff23.png";